module.exports = __webpack_public_path__ + "static/phone-video-9fbae8a14655e1de68bab54859eb9a41.mp4";